import React, { useEffect, useState } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import { useSelector, useDispatch } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { push } from "connected-react-router";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import useSchema from "hooks/useSchema";
import { actions as creditBillsActions } from "reducers/creditBills";
import TextField from "pages/_components/fields/TextField";
import Selector from "pages/_components/fields/formik/Selector";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import Button from "pages/_components/Button";
import ProductList from "pages/_components/product/SimpleList";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool } from "prop-types";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import { actions as accountsActions } from "reducers/accounts";
import BillInfoSummary from "../components/BillsInfoSummary";
import TitleColumns from "./components/TitleColumns";
import ItemRow from "./components/ItemRow";

const FORM_ID = "credit.bills.modify";

const DetailCreditBills = ({ isDesktop }) => {
    const { actionData } = useSelector((state) => state.creditBills);
    const [showInfoText, setShowInfoText] = useState(true);
    const { accounts } = useSelector((state) => state.accounts);
    const row = isDesktop ? 1 : 4;
    const dispatch = useDispatch();
    const { stringRequired } = useSchema();
    const initialValues = {
        cbu: "",
        newCbu: "",
    };
    useEffect(() => {
        dispatch(accountsActions.listAccountsCbu());
    }, []);

    const validateBills = Yup.lazy((values) => {
        let validate;
        if (values.cbu === "otra") {
            validate = {
                cbu: stringRequired,
                newCbu: stringRequired,
            };
        } else {
            validate = {
                cbu: stringRequired,
            };
        }

        return Yup.object().shape(validate);
    });

    const totalAmount = actionData?.invoiceList?.reduce((accumulator, object) => accumulator + object.saldoAceptado, 0);

    const accountOptions = accounts?.map((data) => ({
        value: data?.cbu?.substring(9),
        label: data?.cbu?.substring(9),
    }));
    accountOptions.unshift({ value: "otra", label: "Otra" });

    const cbuOptions = accounts ? accountOptions : [{ value: "otra", label: "Otra" }];

    const handleSubmit = (values) => {
        const cbu = values.cbu === "otra" ? values.newCbu : values.cbu;
        dispatch(creditBillsActions.setActionData({ ...actionData, totalAmount, cbu }));
        dispatch(push("/creditBills/inform/sumary"));
    };

    const hasBills = actionData?.invoiceList?.length > 1;

    return (
        <>
            <Notification scopeToShow="inform.modify.cbu" />
            <ResponsiveHeader id="credit.bills.modify.cbu.title" />
            <MainContainer className="credit-bills">
                <ProductList
                    fetchingWithPreviousData
                    items={actionData?.invoiceList || []}
                    noDataText="global.no.results"
                    noFiltersDataText="global.no.results"
                    renderItem={(item) => (
                        <GridTable.Container
                            rows={row}
                            key={`action-bill-item-${item.facturaId.numeroComprobante}`}
                            className={!isDesktop && "box box-shadow"}>
                            <ItemRow data={item} isDesktop={isDesktop} showButton={hasBills} />
                        </GridTable.Container>
                    )}>
                    {(listItem) => (
                        <GridTable className="tablelist-inform">
                            {isDesktop && (
                                <GridTable.Header>
                                    <GridTable.Container rows={row}>
                                        <TitleColumns showButton={hasBills} />
                                    </GridTable.Container>
                                </GridTable.Header>
                            )}
                            <GridTable.Body>{listItem}</GridTable.Body>
                        </GridTable>
                    )}
                </ProductList>
                {hasBills && <BillInfoSummary bills={actionData?.invoiceList} isDesktop={isDesktop} />}

                {showInfoText && (
                    <div className="credit-bills-sumary-note">
                        <CustomData
                            icon="images/information_fill.svg"
                            titleText="credit.bills.modify.text"
                            titleTextType="I18N"
                        />
                        <CustomButton
                            icon="images/figma/icon/cross.svg"
                            func={() => setShowInfoText(false)}
                            lassName="toolbar-item"
                        />
                    </div>
                )}

                <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validateBills}>
                    {({ values }) => (
                        <Form>
                            <Row>
                                <Col xs={12} md={12}>
                                    <Field
                                        component={Selector}
                                        idForm={FORM_ID}
                                        name="cbu"
                                        options={cbuOptions}
                                        placeholder={`${i18n.get("global.select")}`}
                                    />
                                </Col>
                            </Row>
                            {values.cbu === "otra" && (
                                <Row>
                                    <Col xs={12} md={6}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="newCbu"
                                            pattern="[0-9]*"
                                            type="text"
                                            maxLength="150"
                                            hidePlaceholder
                                        />
                                    </Col>
                                </Row>
                            )}

                            <Row className="form-actions">
                                <Col xs={12} md={4} mdOffset={4}>
                                    <Button
                                        type="submit"
                                        className="btn-primary"
                                        label="global.continue"
                                        disabled={values.cbu === "otra" ? !values.cbu || !values.newCbu : !values.cbu}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

DetailCreditBills.propTypes = {
    isDesktop: bool.isRequired,
};

export default DetailCreditBills;
